import { Mapper } from "../../../../../core/base";
import { PlanMockEntity } from "./plan-mock-entity";
import { Plan } from "../../../../../core/domain";

export class PlanMockRepositoryMapper extends Mapper<PlanMockEntity, Plan> {

  mapFrom(param: PlanMockEntity): Plan {
    return {
      id: param.id,
      name: param.name,
      description: param.description,
      distance: param.distance,
      duration: param.duration,
      jobsCount: param.jobsCount,
      locationsCount: param.locationsCount,
      planTypeId: param.planTypeId,
      createdAt: param.createdAt
    };
  }

  mapTo(param: Plan): PlanMockEntity {
    return {
      id: param.id!,
      name: param.name,
      description: param.description,
      distance: param.distance,
      duration: param.duration,
      jobsCount: param.jobsCount,
      locationsCount: param.locationsCount,
      planTypeId: param.planTypeId,
      createdAt: param.createdAt
    };
  }

}
